module.exports = __webpack_public_path__ + "img/our-organisation.9a9076b1.png";